import React, { useMemo } from 'react';
import { Caption } from 'components/Typography/Typography';
import CustomLink from 'components/CustomLink/CustomLink';
import { translate } from 'components/Translation';
import styles from 'assets/jss/material-dashboard-pro-react/views/numberDetails/servicesStyle';
import { makeStyles } from '@material-ui/core';
import CustomCheckbox from 'components/CustomCheckbox/CustomCheckbox';
import ErrorBox from 'components/ErrorBox/ErrorBox';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import TermsAndConditionsTooltip from 'components/CustomTooltip/TermsAndConditionsTooltip';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IDialogTermsAndConditionsProps {
	termsAndConditions?: types.services.termsAndConditions;
	showCheckbox: boolean;
	isChecked: boolean;
	setIsChecked: React.Dispatch<React.SetStateAction<boolean>>;
	showError: boolean;
}

const DialogTermsAndConditions = ({
	termsAndConditions,
	isChecked,
	setIsChecked,
	showError,
	showCheckbox,
}: IDialogTermsAndConditionsProps) => {
	const classes = useStyles();

	const check = () => {
		setIsChecked((checked) => !checked);
	};

	const url = termsAndConditions?.type === 'link' ? termsAndConditions.url : '';
	const textUrl = termsAndConditions?.type === 'link' ? termsAndConditions.textUrl : '';
	const acceptText = termsAndConditions?.type === 'link' ? termsAndConditions.acceptText : '';

	const content = termsAndConditions?.type === 'tooltip' ? termsAndConditions.content : null;

	const text: React.ReactElement | null = useMemo(() => {
		if (termsAndConditions?.type === 'link' && termsAndConditions.text) {
			if (Array.isArray(termsAndConditions.text)) {
				return (
					<>
						{termsAndConditions.text.map((text, index) => (
							<Caption color="secondary-light" disableMargin key={index}>
								{text}
							</Caption>
						))}
					</>
				);
			} else {
				return (
					<Caption color="secondary-light" disableMargin>
						{termsAndConditions.text}
					</Caption>
				);
			}
		}
		return null;
	}, [termsAndConditions]);

	return (
		<>
			<ConditionalRender
				show={termsAndConditions?.type === 'link'}
				onTrue={() => (
					<div>
						{text}
						<div className={classes.termsAndConditionsLink}>
							<CustomLink to={url} color="brand" type="bodySBold" target="_blank">
								{translate(textUrl ? textUrl : 'number.services.terms.conditions')}
							</CustomLink>
						</div>
					</div>
				)}
			/>
			<ConditionalRender
				show={termsAndConditions?.type === 'tooltip'}
				onTrue={() => (
					<div>
						<TermsAndConditionsTooltip placement="bottom">{content}</TermsAndConditionsTooltip>
					</div>
				)}
			/>
			<ConditionalRender
				show={showCheckbox}
				onTrue={() => (
					<div className={classes.acceptTermsAndConditions}>
						<CustomCheckbox
							onClick={check}
							checked={isChecked}
							label={translate(acceptText ? acceptText : 'number.services.accept.terms.and.conditions')}
							size="sm"
						/>
						<ConditionalRender
							show={showError && !isChecked}
							onTrue={() => (
								<div className={classes.termsAndConditionsErrorBoxWrapper}>
									<ErrorBox text={translate('number.services.accept.terms.and.conditions.error')} />
								</div>
							)}
						/>
					</div>
				)}
			/>
		</>
	);
};

export default DialogTermsAndConditions;
